<div class="order-empty">

    @if (!featureFlagController.isBlocked('generate_with_ia')) {
        <!-- A IA é a manchete da tela: o peso vem do texto e do campo largo, não de um
             card esticado. Os outros caminhos continuam a um clique no "+ Novo" da lista
             ao lado, então não disputam espaço aqui. -->
        <div class="ia-hero">
            <span class="ia-hero__badge">
                <ra-icon icon="magicpen" varColor="primary" [size]="14" />
                {{ 'order.empty.iaBadge' | translate }}
            </span>

            <h1>{{ 'order.empty.iaHeadline' | translate }}</h1>
            <p>{{ 'order.empty.iaHint' | translate }}</p>

            <div class="ia-hero__field">
                <label class="ia-hero__label" for="order-empty-prompt">
                    {{ 'order.empty.iaHeadline' | translate }}
                </label>
                <input
                    id="order-empty-prompt"
                    type="text"
                    [value]="prompt()"
                    [placeholder]="'order.empty.iaPlaceholder' | translate"
                    (input)="onPromptInput($event)"
                    (keydown)="onPromptKey($event)" />

                <button
                    type="button"
                    class="ia-hero__attach"
                    [attr.aria-label]="'order.empty.iaAttach' | translate"
                    (click)="start()">
                    <ra-icon icon="gallery" varColor="contentSecondary" [size]="18" />
                </button>

                <button type="button" class="ia-hero__submit" (click)="start()">
                    {{ 'order.empty.iaCta' | translate }}
                </button>
            </div>
        </div>
    } @else {
        <!-- Sem IA no plano a manchete não existe, e a tela não pode ficar sem saída:
             aqui os caminhos de criação voltam a ser o conteúdo. -->
        <div class="order-empty__fallback">
            <h1>{{ 'order.empty.title' | translate }}</h1>
            <p>{{ 'order.empty.subtitleNoIa' | translate }}</p>

            <div class="order-empty__paths">
                <button type="button" class="path-card" (click)="newService()">
                    <span class="path-card__figure path-card__figure--service">
                        <ra-icon icon="folder" varColor="primary" [size]="21" />
                    </span>
                    <span class="path-card__texts">
                        <strong>{{ 'order.feed.newService' | translate }}</strong>
                        <small>{{ 'order.empty.serviceHint' | translate }}</small>
                    </span>
                </button>

                <button type="button" class="path-card" (click)="newDocument()">
                    <span class="path-card__figure">
                        <ra-icon icon="document-normal" varColor="contentSecondary" [size]="21" />
                    </span>
                    <span class="path-card__texts">
                        <strong>{{ 'order.feed.newDocument' | translate }}</strong>
                        <small>{{ 'order.empty.documentHint' | translate }}</small>
                    </span>
                </button>

                @if (!featureFlagController.isBlocked('import_files')) {
                    <button type="button" class="path-card" (click)="importFile()">
                        <span class="path-card__figure">
                            <ra-icon icon="document-upload" varColor="contentSecondary" [size]="21" />
                        </span>
                        <span class="path-card__texts">
                            <strong>{{ 'order.empty.importTitle' | translate }}</strong>
                            <small>{{ 'order.empty.importHint' | translate }}</small>
                        </span>
                    </button>
                }
            </div>
        </div>
    }

</div>
